import "./app.scss";
import { isEqual } from "lodash";
import React, { lazy, Suspense, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, useLocation } from "react-router-dom";
import { OidcCallback } from "components";
import { InsProgressIndicator } from "components/widgets/base/insProgressIndicator";
import { appInsightEvents } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { userManager } from "plugins/oidc";
import { setApplicationBackButtonClicked } from "store/current-dashboard";
import { getCurrentLocalTime } from "common/date-utils";
const Content = lazy(() => import("content"));
const App = () => {
    const dispatch = useDispatch();
    const isApplicationBackButtonClicked = useSelector((state) => state.currentDashboard.isApplicationBackButtonClicked, isEqual);
    const handleBackButtonClick = useCallback(() => {
        if (!isApplicationBackButtonClicked) {
            appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.BrowserBackButton, properties: { LocalTimestamp: getCurrentLocalTime() } });
            dispatch(setApplicationBackButtonClicked(false));
        }
    }, [dispatch, isApplicationBackButtonClicked]);
    useEffect(() => {
        window.addEventListener("popstate", handleBackButtonClick);
        return () => {
            window.removeEventListener("popstate", handleBackButtonClick);
        };
    }, [handleBackButtonClick]);
    const user = useSelector((state) => state.auth.oidc?.user);
    const logout = useSelector((state) => state.auth.common.logout);
    const location = useLocation();
    if (location.pathname !== "/callback" && (!user || user.expired) && !logout) {
        userManager.signinRedirect({ state: { origin: window.location.origin, path: window.location.pathname + window.location.search } });
        return React.createElement("div", { className: "app-loading" },
            React.createElement(InsProgressIndicator, null));
    }
    return React.createElement(Suspense, { fallback: React.createElement("div", { className: "app-loading" },
            React.createElement(InsProgressIndicator, null)) },
        user && React.createElement(Content, null),
        React.createElement(Route, { path: "/callback", component: OidcCallback }));
};
export default App;
